const TEXT_BUTTON_HEADINGS = "text-button-headings";
export {
  TEXT_BUTTON_HEADINGS
};
//# sourceMappingURL=data-hooks.js.map
